import { InvestmentRoundingSetting } from 'shared';

import { StringKey } from '../lang/index';

export const InvestmentRoundingSettingTitle: Record<InvestmentRoundingSetting, StringKey> = {
  [InvestmentRoundingSetting.DEFAULT]: 'ROUNDING_SETTINGS_DEFAULT',
  [InvestmentRoundingSetting.ROUND_UP]: 'ROUNDING_SETTINGS_ROUND_UP',
  [InvestmentRoundingSetting.ROUND_DOWN]: 'ROUNDING_SETTINGS_ROUND_DOWN',
};

export const InvestmentRoundingSettingTooltipDesc: Record<InvestmentRoundingSetting, StringKey> = {
  [InvestmentRoundingSetting.DEFAULT]: 'ROUNDING_SETTINGS_TOOLTIP_DEFAULT_DESC',
  [InvestmentRoundingSetting.ROUND_UP]: 'ROUNDING_SETTINGS_TOOLTIP_ROUND_UP_DESC',
  [InvestmentRoundingSetting.ROUND_DOWN]: 'ROUNDING_SETTINGS_TOOLTIP_ROUND_DOWN_DESC',
};

export const investmentRoundingTooltipSectionOrder: InvestmentRoundingSetting[] = [
  InvestmentRoundingSetting.DEFAULT,
  InvestmentRoundingSetting.ROUND_UP,
  InvestmentRoundingSetting.ROUND_DOWN,
];
